import { Box } from '@shared/ui';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
// biome-ignore lint/style/noRestrictedImports: the route owns both feature views so invalid targets can replace the full selected-coach shell.
import CoachProfileNavigation from '../admin/components/CoachProfileNavigation';
import AdminCalendarView from './AdminCalendarView';

export default function AdminCoachCalendarRoute() {
  const { coachId } = useParams<{ coachId: string }>();
  const [searchParams] = useSearchParams();
  const memberId = searchParams.get('memberId')?.trim();
  if (!coachId) {
    return <Navigate to="/admin/coaches" replace />;
  }

  return (
    <Box sx={{ maxWidth: 1200, margin: '0 auto', padding: 3 }}>
      <AdminCalendarView
        personId={coachId}
        memberPersonId={memberId || undefined}
        navigation={<CoachProfileNavigation coachId={coachId} activeTab="calendar" />}
      />
    </Box>
  );
}
